/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSqrt } from '../../factoriesNumber.js';
export var sqrtDependencies = {
  typedDependencies,
  createSqrt
};